import UserSurvey from '@/components/userSurvey/quickSurvey';
import { useElementSize } from '@custom-react-hooks/use-element-size';
import { Box } from '@mui/material';

const UserSurveyPage = () => {
  const [containerRef, containerSize] = useElementSize();

  return (
    <Box ref={containerRef} sx={{ height: '100%' }}>
      <UserSurvey maxHeight={containerSize.height} />
    </Box>
  );
};

export default UserSurveyPage;
